// Auth mutations and account writes in cooperating tabs share this lock.
export async function withSessionLock<T>(work: () => Promise<T>): Promise<T> {
  if (typeof navigator !== 'undefined' && navigator.locks) {
    return navigator.locks.request('festival-account-write', work);
  }
  return work();
}
